module.exports = __webpack_public_path__ + "static/media/kinsmen_mac.d5f1234f.png";